import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const radio: ThemeUICSSObject = {
  input: {
    height: '32px !important',
  },
  'input[role][readonly]~svg': {
    cursor: 'not-allowed',
  },
  legend: { fontWeight: 'bold !important' },
};

export default radio;
